const stepEvents = {
  methods: {
    handleNextStep() {
      this.$emit('nextStep')
    },
    handlePrevStep() {
      this.$emit('prevStep')
    }
  }
}

export default stepEvents
